module.exports = __webpack_public_path__ + "img/DE05793.9da395fa.png";